import { styled } from "styled-components";

export const SignInContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 450px;

  h2 {
    margin: 10px 0;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
